import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Search } from "lucide-react";

export default function NotFound() {
    return (
        <div
            data-testid="notfound-page"
            className="min-h-[80vh] bg-aimploy-bg flex items-center relative overflow-hidden"
        >
            <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-aimploy-violet/10 blur-3xl" />
            <div className="absolute -bottom-40 -left-40 h-[500px] w-[500px] rounded-full bg-aimploy-navy/5 blur-3xl" />

            <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7">
                    <span className="text-xs uppercase tracking-[0.2em] text-aimploy-violet font-semibold">
                        Fehler 404
                    </span>
                    <h1 className="font-display text-7xl sm:text-8xl lg:text-9xl font-bold leading-[0.85] tracking-tight mt-6">
                        Seite nicht
                        <br />
                        <span className="italic font-medium text-aimploy-violet">besetzt.</span>
                    </h1>
                    <p className="text-aimploy-muted text-lg mt-8 max-w-md leading-relaxed">
                        Diese URL haben wir leider nicht in unserer Datenbank — genau wie eine Stelle, die noch
                        unbesetzt ist. Lassen Sie uns gemeinsam die richtige Position finden.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 mt-10">
                        <Link
                            to="/"
                            data-testid="notfound-home"
                            className="inline-flex items-center justify-center gap-2 bg-aimploy-navy hover:bg-aimploy-navy-hover text-white px-7 py-3.5 rounded-full text-sm font-semibold hover:scale-[1.02] active:scale-[0.98] transition-all"
                        >
                            <Home className="w-4 h-4" />
                            Zur Startseite
                        </Link>
                        <Link
                            to="/kandidaten"
                            data-testid="notfound-jobs"
                            className="inline-flex items-center justify-center gap-2 bg-white text-aimploy-navy border border-aimploy-navy/15 hover:border-aimploy-violet hover:text-aimploy-violet px-7 py-3.5 rounded-full text-sm font-semibold transition-all"
                        >
                            <Search className="w-4 h-4" />
                            Offene Rollen
                        </Link>
                        <Link
                            to="/kontakt"
                            className="inline-flex items-center justify-center gap-2 px-5 py-3.5 text-sm font-semibold text-aimploy-navy hover:text-aimploy-violet transition-colors"
                        >
                            Kontakt
                            <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>

                <div className="lg:col-span-5 hidden lg:flex justify-center">
                    <div className="relative">
                        <div className="font-display text-[260px] xl:text-[320px] font-bold leading-none text-aimploy-navy/5 select-none">
                            404
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-aimploy-navy text-white rounded-3xl p-8 max-w-[280px] rotate-3 shadow-[0_30px_80px_rgba(26,26,46,0.18)]">
                                <div className="text-xs uppercase tracking-[0.2em] text-aimploy-violet font-semibold mb-2">
                                    Tipp
                                </div>
                                <p className="font-display text-lg font-bold leading-tight">
                                    Vielleicht ist die Seite umgezogen — wie ein guter Kandidat zu einem besseren Angebot.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
